import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CommentDialog, ConfirmDialog } from '@shared';
import { SuccessDialog } from '@shared/components/success-dialog/success-dialog';

@Injectable({
  providedIn: 'root',
})
export class Dialog {
  private dialog = inject(MatDialog);

  openComments(
    label: string = 'Kindly Input your comments',
    placeholder: string = 'Input your comments here...',
    sublabel?: string,
    onSubmit?: (value: string) => Observable<unknown>,
  ) {
    return this.dialog.open(CommentDialog, {
      width: '400px',
      data: { label, sublabel, placeholder, onSubmit },
    });
  }

  openConfirmDialog(
    title: string = '',
    message: string = '',
    confirmText: string = '',
    cancelText: string = '',
  ) {
    return this.dialog.open(ConfirmDialog, {
      width: '400px',
      data: { title, message, confirmText, cancelText },
      panelClass: 'securepay-dialog',
      disableClose: true,
    });
  }

  openConfirmDialogWithObject(
    title: string = '',
    message: string = '',
    confirmText: string = '',
    cancelText: string = '',
  ) {
    return this.dialog.open(ConfirmDialog, {
      width: '400px',
      data: { title, message, confirmText, cancelText },
      panelClass: 'securepay-dialog',
      disableClose: true,
    });
  }

  openSuccessDialog(
    title: string = '',
    message: string = '',
    action = 'Proceed to Home',
  ) {
    return this.dialog.open(SuccessDialog, {
      width: '400px',
      data: { title, message, action },
      panelClass: 'securepay-dialog',
      disableClose: true,
    });
  }
}
